module.exports = __webpack_public_path__ + "static/img/3_9_1.f6a07117.jpg";